import React from 'react'
import { XStack, YStack } from 'tamagui'

import { Card } from '@newComponents/Card'
import { Icon } from '@newComponents/Icon'
import { Paragraph } from '@newComponents/Text'
import { Link } from '@newComponents/Link'

import { DocSection } from '../shared/DocSection'
import { DocScreenshot } from '../shared/DocScreenshot'

const MultiHost = () => (
  <>
    <Card gap='$4'>
      <Paragraph size='$5'>
        Events on Guild can be co-hosted by multiple Guilds or Users. Multi-host
        Events are a great way to collaborate with other communities, share
        audiences, and run joint gatherings such as cross-community meetups,
        partnerships, or conference tracks.
      </Paragraph>
      <DocScreenshot
        src='docs/events/event-page.png'
        alt='Event page showing the Hosted by section where the host Guild is displayed — co-hosts appear alongside the primary host'
        caption='The Event page shows all hosts in the Hosted by section'
      />
    </Card>

    <Card gap='$4'>
      <DocSection id='how-co-hosting-works' title='How Co-Hosting Works'>
        <YStack gap='$3'>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='person-add' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Adding co-hosts</Paragraph> — Open{' '}
              <Link href='/docs/events/settings'>Event Settings</Link> and go to the{' '}
              <Paragraph size='$5' fontWeight='$7'>Hosts</Paragraph> section. Search
              for the Guild or User you want to invite as a co-host and send the
              invitation. The co-host receives a notification and can accept or decline.
            </Paragraph>
          </XStack>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='people' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>How co-hosting appears</Paragraph>{' '}
              — Once a co-host accepts, they appear alongside the primary host on the{' '}
              <Link href='/docs/events/page'>Event page</Link>. Each host is shown
              with their photo and name, so attendees can see all the communities
              involved at a glance. The Event also appears on each co-hosting Guild's
              Events tab.
            </Paragraph>
          </XStack>
          <XStack gap='$3' alignItems='flex-start'>
            <Icon name='lock-closed' size='$5' color='$color' flexShrink={0} marginTop={2} />
            <Paragraph size='$5'>
              <Paragraph size='$5' fontWeight='$7'>Permissions</Paragraph> — The
              primary host Guild retains full control over Event Settings. Co-hosts
              gain visibility and credit on the Event page but do not automatically
              receive editing permissions. This keeps Event management straightforward
              while still showcasing the collaboration.
            </Paragraph>
          </XStack>
        </YStack>
      </DocSection>
    </Card>

    <Card gap='$4'>
      <DocSection id='multi-host-compatibility' title='Compatibility'>
        <Paragraph size='$5'>
          Multi-host Events work with all Event features, including{' '}
          <Link href='/docs/events/ticketing-overview'>ticketing</Link>,{' '}
          <Link href='/docs/events/rsvps'>RSVPs</Link>, and{' '}
          <Link href='/docs/presentations/overview'>Presentations</Link>. There is
          no limit to the number of co-hosts you can add.
        </Paragraph>
      </DocSection>
    </Card>
  </>
)

export default MultiHost
